<script>
export default {
  props: {
    desiredPieceNumbers: {
      type: Array,
      default: () => [],
    },
  },

  emits: ['changeSerialNumber'],

  computed: {
    hasLimitedNumbersSelected() {
      return !!this.desiredPieceNumbers.length;
    },

    limitedNumberLabel() {
      const selection = this.hasLimitedNumbersSelected ? 'withSelection' : 'withoutSelection';
      return this.$t(`Checkout.limitedNumberLabel.${selection}`);
    },
  },

  methods: {
    changeSerialNumber() {
      this.$emit('changeSerialNumber');
    },
  },
};
</script>

<template>
  <div
    class="limited-serial-number-selection limited-serial-number-selection--checkout"
    data-cy="limited-serial-number-selection"
  >
    <div class="limited-serial-number-selection__content">
      <p class="font-medium my-0">
        {{ limitedNumberLabel }}
        <button
          v-if="!hasLimitedNumbersSelected"
          type="button"
          class="button button--dark button--link flex mx-auto mt-6 md:inline-block md:mt-0"
          data-cy="set-piece-numbers-btn"
          @click="changeSerialNumber"
        >
          {{ $t('Checkout.limitedNumberSelect') }}
        </button>
      </p>
      <ul v-if="hasLimitedNumbersSelected" class="flex flex-row gap-1 justify-center">
        <li v-for="(pieceNumber, key) in desiredPieceNumbers" :key="key">
          <button
            class="limited-serial-number-selection__item"
            name="selected-limited-edition-number-trigger"
            @click="changeSerialNumber"
          >
            {{ pieceNumber }}
          </button>
        </li>
      </ul>

      <button
        v-if="hasLimitedNumbersSelected"
        type="button"
        class="button button--dark button--link mt-3"
        data-cy="set-piece-numbers-btn"
        @click="changeSerialNumber"
      >
        {{ $t('Checkout.limitedNumberChange') }}
      </button>
    </div>
  </div>
</template>
